function parseFeeConfig(value) {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' ? parsed : null;
    }
    catch (_e) {
      return null;
    }
  }

  if (typeof value === 'object') {
    return value;
  }

  return null;
}

function toMoneyNumber(value) {
  if (value == null || value === '') {
    return null;
  }
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function formatMoney(value) {
  const parsed = toMoneyNumber(value);
  if (parsed == null) {
    return '-';
  }
  return `$${parsed.toFixed(2)}`;
}

export {
  parseFeeConfig,
  toMoneyNumber,
  formatMoney,
};
